export const DateTimeCounter = {
	selectors: {
		dateTimeCounterSelector: Array.prototype.slice.call(document.querySelectorAll('.js-datetime-counter'))
	},

	init: function() {
		let self = this;

		self.counterFunction(self.selectors.dateTimeCounterSelector);
	},

	counterFunction: function(_selectors) {
		let self = this;

		let lang = document.querySelector('html').getAttribute('lang');
		let s = 1000;
		let m = s * 60;
		let h = m * 60;
		let d = h * 24;
		let timer, plural;

		_selectors.forEach(function(x) {
			let end = new Date(x.getAttribute('datetime'));

			function showRemaining() {
				let now = new Date();
				let distance = end - now;

				if (distance < 0) {
					distance = 0;
					clearInterval(timer);
				}

				let days = Math.floor(distance / d);
				let hours = Math.floor((distance % d) / h);
				let minutes = Math.floor((distance % h) / m);
				let seconds = Math.floor((distance % m) / s);

				if (minutes < 10) { minutes = '0' + minutes; }
				if (seconds < 10) { seconds = '0' + seconds; }

				if (days <= 0) {
					plural = '';
					days = '';
				} else if (days > 4) {
					plural = 'dní';
				} else if (lang === 'sk') {
					if (days === 1) { plural = 'deň'; }
					else { plural = 'dni'; }
				} else if (lang === 'cs') {
					if (days === 1) { plural = 'den'; }
					else { plural = 'dny'; }
				}

				x.querySelector('span').innerHTML = ' ' + days + ' ' + plural + ' ' + hours + ':' + minutes + ':' + seconds;

			}

			timer = setInterval(showRemaining, 1000);
		});

	}
}

DateTimeCounter.init();
